import { Recipe } from './../../models/recipe';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Urls } from 'src/app/models/urls';
import { tap, catchError } from 'rxjs/operators';
import { Int64Updater } from 'src/app/models/key-value';
import { Variables } from 'src/app/models/variables';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class RecipeService {

  url = new Urls();
  apiUrl: string;

  constructor(
    private httpclient: HttpClient
  ) {
      this.apiUrl = this.url.apiUrl;
  }

  getRecipes(page, size, rid, rname, filt) {
    const v = new Variables();
    const val = localStorage.getItem('oi');
    const oi = CryptoJS.AES.decrypt(val, v.pass).toString(CryptoJS.enc.Utf8).toString();
    const orgId = +oi;
    // tslint:disable-next-line: max-line-length
    const url = this.apiUrl + '/api/recipe/' + page + '/' + size + '/' + orgId + '/' + rid + '/' + rname + '/' + filt + '/';
    return this.httpclient.get<any>(url)
    .pipe(
      tap( // Log the result or error
        error => this.handleError
      )
    );
  }

  postRecipe(recipe: Recipe) {
    return this.httpclient.post(this.apiUrl + '/api/recipe', recipe)
                    .pipe(
                      catchError(this.handleError)
                    );
  }

  putRecipe(val: Int64Updater) {
    return this.httpclient.put(this.apiUrl + '/api/recipe/' + val.Id, val)
                    .pipe(
                      catchError(this.handleError)
                    );
  }

  private handleError(error: any) {
    throw error;
    return error;
  }

}
